import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[680px] md:min-h-[800px] flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=A%20grand%20competitive%20arena%20with%20warm%20golden%20trophy%20in%20center%20surrounded%20by%20soft%20glowing%20particles%2C%20dramatic%20stage%20lighting%2C%20abstract%20geometric%20patterns%20in%20background%2C%20championship%20atmosphere%2C%20dark%20elegant%20background%20with%20warm%20amber%20and%20gold%20accents%2C%20cinematic%20composition&width=1800&height=1000&seq=hero-bg-2026&orientation=landscape')`,
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/50 to-foreground-950/70"></div>

      <div className="relative w-full z-10 px-4 md:px-6 py-20 md:py-0">
        <div className="max-w-[1400px] mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-500/20 border border-primary-500/30 text-primary-300 text-sm mb-8 backdrop-blur-sm">
            <i className="ri-fire-line"></i>
            <span>今日已有 12,580 人参与竞技</span>
          </div>

          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-foreground-50 leading-tight mb-6">
            每天参与竞技
            <br />
            <span className="text-primary-400">赢取丰厚奖励</span>
          </h1>

          <p className="text-lg md:text-xl text-foreground-200/80 max-w-2xl mx-auto mb-10 leading-relaxed">
            每日大赛是您每天不可错过的竞技盛宴！与全国玩家同台竞技，
            每日更新赛制，公平透明，新手老手皆可参与，开启您的每日挑战之旅！
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-base font-medium hover:bg-primary-600 transition-all hover:scale-105 whitespace-nowrap cursor-pointer">
              立即参与今日赛事
              <i className="ri-arrow-right-line ml-2"></i>
            </button>
            <Link
              to="/about"
              className="px-8 py-3.5 rounded-full border border-foreground-200/30 text-foreground-100 text-base font-medium hover:bg-foreground-50/10 transition-all whitespace-nowrap cursor-pointer"
            >
              了解更多
            </Link>
          </div>

          <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-6 max-w-3xl mx-auto">
            {[
              { value: '50万+', label: '注册用户' },
              { value: '6大', label: '赛事类别' },
              { value: '每日', label: '赛事更新' },
              { value: '10万+', label: '累计奖品' },
            ].map((stat, i) => (
              <div key={i} className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-400 font-heading">{stat.value}</div>
                <div className="text-sm text-foreground-300/80 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}